export default __webpack_public_path__ + "static/media/icons-17.3c3d630f.svg";